/**
 * Environment (CNPWKS-0001). Class-(b) runtime-bootstrap app: the API is same-origin at `/api/*`;
 * every other platform host comes from `GET /api/bootstrap`. The only build variable is the
 * deploy-environment flag (vite.config.ts refuses a build without it).
 */
export type DeployEnv = 'staging' | 'production';

export interface AppEnv {
  deployEnv: DeployEnv;
  /** This app's own origin, from the browser. */
  appOrigin: string;
  /** cnp-api base: this origin + `/api` (the edge rewrites `/api/*` to `/cnp-api/*`). */
  apiBaseUrl: string;
}

export function normalizeDeployEnv(value: string | undefined): DeployEnv | null {
  const v = value?.trim().toLowerCase();
  return v === 'staging' || v === 'production' ? v : null;
}

/** Fallback for an unflagged run (dev server, tests): a `staging` host label means staging. */
export function inferDeployEnv(hostname: string): DeployEnv {
  return hostname.toLowerCase().split('.').includes('staging') ? 'staging' : 'production';
}

const origin = window.location.origin;

export const env: AppEnv = {
  deployEnv:
    normalizeDeployEnv(import.meta.env.VITE_DEPLOY_ENV) ?? inferDeployEnv(window.location.hostname),
  appOrigin: origin,
  apiBaseUrl: `${origin}/api`,
};
